<template>
  <v-flex xs12>
    <v-card>
      <v-card-title>
        <v-icon left>mdi-briefcase</v-icon>
        <router-link style="color: rgba(0, 0, 0, 0.87)"
          :to="`/client/analytics/explorer?opportunity=${opportunity.id}`">
          {{ opportunity.name }}
        </router-link>
        <v-spacer />
        <router-link v-if="opportunity.set.length"
          style="color: rgba(0, 0, 0, 0.87)"
          :to="`/client/analytics/explorer?set=${opportunity.set}`">
          {{ opportunity.set }}
        </router-link>
      </v-card-title>
      <v-divider />
      <v-card-text v-if="!hasApplications" class="text-xs-center">
        <em>No applications have been recorded for this opportunity.</em>
      </v-card-text>
      <v-card-text v-if="statuses.loading || funnel.loading" class="text-xs-center">
        <em>Loading…</em>
      </v-card-text>
      <v-card-text v-if="hasApplications && !statuses.loading && !funnel.loading">
        <apex v-if="!funnel.loading"
          type="bar"
          width="100%"
          :height="linearChartSize(Object.keys(funnel).length)"
          :options="{
            labels: [opportunity.name],
            colors,
            chart: { fontFamily: 'Heebo, sans-serif', toolbar: { show: false } },
            plotOptions: {
              bar: {
                horizontal: true,
                dataLabels: { position: 'top' },
              },
            },
            tooltip: { followCursor: true },
            yaxis: { show: false },
          }"
          :series="Object.keys(funnel).map(name => ({ name, data: [funnel[name]]}))"
        />
        <apex v-if="!statuses.loading"
          type="donut"
          width="100%"
          :height="Object.keys(statuses).length < 20 ? 400 : Object.keys(statuses).length * 18"
          :options="{
            labels: Object.keys(statuses),
            colors: cycledColors,
            chart: { fontFamily: 'Heebo, sans-serif' },
            tooltip: { enabled: false },
            legend: { position: 'bottom' },
            plotOptions: {
              pie: {
                donut: {
                  labels: {
                    show: true,
                    total: { show: true, color: '#373d3f' },
                  },
                },
              },
            },
          }"
          :series="Object.values(statuses)"
        />
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
// Data
import colors from '@/data/colors'

// Component
export default {
  props: {
    opportunity: { type: Object },
  },
  created() {
    Vue.$http.get(`client/opportunities/${this.opportunity.id}/analytics/funnel`).then(({ data }) => (this.funnel = data))
    Vue.$http.get(`client/opportunities/${this.opportunity.id}/analytics/statuses`).then(({ data }) => (this.statuses = data))
  },
  data() {
    return {
      colors: colors.analytics,
      statuses: { loading: true },
      funnel: { loading: true },
    }
  },
  computed: {
    hasApplications() { return this.opportunity.applicationsCount > 0 },
    cycledColors() {
      return [this.colors[0]].concat(this.colors.slice(2))
    }
  },
  methods: {
    linearChartSize(count) {
      return 100 + count * 20
    },
  },
}
</script>
